import cn from "classnames";
// Styles
import styles from "./DayPicker.module.scss";

const DayPicker = ({ selectedDay, onDayChange }) => {
  return (
    <div className={styles.root}>
      <button
        type="button"
        className={cn(styles.fullText, {
          [styles.active]: selectedDay === "Monday",
        })}
        onClick={() => onDayChange("Monday")}
      >
        Monday
      </button>
      <button
        type="button"
        className={cn(styles.shortText, {
          [styles.active]: selectedDay === "Monday",
        })}
        onClick={() => onDayChange("Monday")}
      >
        Mon
      </button>

      <button
        type="button"
        className={cn(styles.fullText, {
          [styles.active]: selectedDay === "Tuesday",
        })}
        onClick={() => onDayChange("Tuesday")}
      >
        Tuesday
      </button>
      <button
        type="button"
        className={cn(styles.shortText, {
          [styles.active]: selectedDay === "Tuesday",
        })}
        onClick={() => onDayChange("Tuesday")}
      >
        Tue
      </button>

      <button
        type="button"
        className={cn(styles.fullText, {
          [styles.active]: selectedDay === "Wednesday",
        })}
        onClick={() => onDayChange("Wednesday")}
      >
        Wednesday
      </button>
      <button
        type="button"
        className={cn(styles.shortText, {
          [styles.active]: selectedDay === "Wednesday",
        })}
        onClick={() => onDayChange("Wednesday")}
      >
        Wed
      </button>

      <button
        type="button"
        className={cn(styles.fullText, {
          [styles.active]: selectedDay === "Thursday",
        })}
        onClick={() => onDayChange("Thursday")}
      >
        Thursday
      </button>
      <button
        type="button"
        className={cn(styles.shortText, {
          [styles.active]: selectedDay === "Thursday",
        })}
        onClick={() => onDayChange("Thursday")}
      >
        Thu
      </button>

      <button
        type="button"
        className={cn(styles.fullText, {
          [styles.active]: selectedDay === "Friday",
        })}
        onClick={() => onDayChange("Friday")}
      >
        Friday
      </button>
      <button
        type="button"
        className={cn(styles.shortText, {
          [styles.active]: selectedDay === "Friday",
        })}
        onClick={() => onDayChange("Friday")}
      >
        Fri
      </button>

      <button
        className={cn(styles.fullText, {
          [styles.active]: selectedDay === "Saturday",
        })}
        onClick={() => onDayChange("Saturday")}
      >
        Saturday
      </button>
      <button
        className={cn(styles.shortText, {
          [styles.active]: selectedDay === "Saturday",
        })}
        onClick={() => onDayChange("Saturday")}
      >
        Sat
      </button>
    </div>
  );
};

export default DayPicker;
